import { ITEMS } from '../../../../constants';
import { isType } from '../../../../services/products';
import geometry from '../../../../scene/util/geometry';
import productService from '../../../../services/products';

const itemShouldIgnoreDrawer = (item, drawer, parent) => {
  const shelfCollisions = geometry.getCollidingRects(
    drawer,
    parent.items.filter(item => productService.isType(item, ITEMS.SHELF))
  );

  if (shelfCollisions.length) {
    return false;
  }

  const drawersColliding = parent.items.filter(
    item =>
      item.itemid !== drawer.itemid &&
      productService.isType(item, ITEMS.DRAWER) &&
      geometry.collides(drawer, item)
  );

  if (!drawersColliding.length) {
    return true;
  }

  const drawersCollidingAbove = drawersColliding.filter(
    other => other.y > drawer.y
  );
  const drawersCollidingBelow = drawersColliding.filter(
    other => other.y < drawer.y
  );

  if (
    productService.isType(item, ITEMS.SHELF) &&
    drawersCollidingAbove.length &&
    drawersCollidingBelow.length
  ) {
    return false;
  }

  if (drawersCollidingAbove.length && item.y < drawer.y) {
    return drawersCollidingAbove.every(drawer =>
      itemShouldIgnoreDrawer(item, drawer, {
        items: parent.items.filter(item => item.y > drawer.y),
      })
    );
  }

  if (drawersCollidingBelow.length && item.y > drawer.y) {
    return drawersCollidingBelow.every(drawer =>
      itemShouldIgnoreDrawer(item, drawer, {
        items: parent.items.filter(item => item.y < drawer.y),
      })
    );
  }

  return false;
};

const drawerShouldIgnoreShelf = (drawer, shelf, parent) => {
  const shelfCollidingDrawers = geometry.getCollidingRects(
    shelf,
    parent.items.filter(item => productService.isType(item, ITEMS.DRAWER))
  );

  if (shelfCollidingDrawers.length) {
    // Shelf already collides with another drawer.
    return false;
  }

  const drawerCollidingShelves = geometry.getCollidingRects(
    drawer,
    parent.items.filter(item => productService.isType(item, ITEMS.SHELF))
  );

  if (
    drawerCollidingShelves.length > 1 &&
    drawerCollidingShelves.some(rect => rect === shelf)
  ) {
    // Drawer would collide with two shelves.
    return false;
  }

  return true;
};

const drawerShouldIgnoreDrawer = (drawer, drawerSibling, parent) => {
  if (drawer.y === drawerSibling.y) {
    return false;
  }

  const allColliding = geometry.getCollidingRects(drawer, parent.items);
  const shelvesColliding = allColliding.filter(item =>
    productService.isType(item, ITEMS.SHELF)
  );
  const drawersColliding = allColliding.filter(item =>
    productService.isType(item, ITEMS.DRAWER)
  );

  if (shelvesColliding.length) {
    // Drawer collides with one shelf,
    // meaning all other colliding drawers needs to be free from shelves
    return drawersColliding.every(other =>
      itemShouldIgnoreDrawer(drawer, other, parent)
    );
  }

  if (drawersColliding.length > 1) {
    // Drawer collides with other drawers on both sides,
    // meaning at least one of them needs to be free of shelves.
    return drawersColliding.some(other =>
      itemShouldIgnoreDrawer(drawer, other, parent)
    );
  }

  return true;
};

const shouldIgnoreCollision = (item, parent, candidate) => {
  if (
    productService.isType(item, ITEMS.SHELF) &&
    productService.isType(candidate, ITEMS.DRAWER)
  ) {
    return itemShouldIgnoreDrawer(item, candidate, parent);
  }

  if (
    productService.isType(item, ITEMS.DRAWER) &&
    productService.isType(candidate, ITEMS.SHELF)
  ) {
    return drawerShouldIgnoreShelf(item, candidate, parent);
  }

  if (
    [item, candidate].every(item => productService.isType(item, ITEMS.DRAWER))
  ) {
    return drawerShouldIgnoreDrawer(item, candidate, parent);
  }

  return false;
};

function filterSlots(slots) {
  const DRAWER_MAX_Y = 1400;

  return slots.filter(slot => {
    if (isType(slot, ITEMS.DRAWER)) {
      return slot.y + slot.height <= DRAWER_MAX_Y;
    }
    return true;
  });
}

function getDependentItems(item, tac) {
  //Not implemented for bror
  return [];
}

function getSlotSources(item, tac) {
  //Not implemented for bror
  return [];
}

export default {
  filterSlots,
  getDependentItems,
  getSlotSources,
  shouldIgnoreCollision,
};
